import { MemeList } from './MemeList';

export class SearchableMemeList extends MemeList {}
